/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Good_Teary_Ant_ArriveInputs */

const fr_good_teary_ant_arrive = /** @type {(inputs: Good_Teary_Ant_ArriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Êtes vous sur de vouloir supprimer ce cours/programmation ?`)
};

/**

* @param {Good_Teary_Ant_ArriveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const good_teary_ant_arrive = /** @type {((inputs?: Good_Teary_Ant_ArriveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Good_Teary_Ant_ArriveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_good_teary_ant_arrive(inputs)
});